import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/topicSitemap/pageContext';

export function TopicSitemapErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Topic sitemap page (error: ${error})`);
}
